export const isBrowser = typeof window !== 'undefined' && window.document;

export function getPrefixTag(tags: string[]) {
  if (tags && Array.isArray(tags) && tags.length) {
    let tagPrefix;
    for (let i = 0, length = tags.length; i < length; i++) {
      const splitTag = tags[i].split('_');
      const lastTag = splitTag[splitTag.length - 1];

      if (lastTag && lastTag === 'ADDRESS') {
        tagPrefix = tags[i].replace('ADDRESS', '');
        break;
      }
    }

    return tagPrefix;
  }
  return;
}
